import React, { useState } from 'react';

function AhaMomentUserTable({ userid, entries }) {
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);

  return (
    <div
      key={userid}
      style={{
        marginBottom: '1rem',
        border: '1px solid #eee',
        borderRadius: '10px',
        overflow: 'hidden',
      }}
    >
      <div
        onClick={toggle}
        style={{
          backgroundColor: '#FFF1E7',
          padding: '12px 16px',
          cursor: 'pointer',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          fontWeight: 'bold',
          color: '#232830',
        }}
      >
        <span>User ID: {userid}</span>
        <span>{entries.length} Messages {isOpen ? '🔽' : '▶️'}</span>
      </div>

      {isOpen && (
        <table
          style={{
            width: '100%',
            borderCollapse: 'collapse',
            fontFamily: 'Nunito Sans',
            fontSize: '14px',
          }}
        >
          <thead>
            <tr style={{ backgroundColor: '#FFF7F0' }}>
              <th style={{ padding: '10px', borderBottom: '1px solid #ddd' }}>Course</th>
              <th style={{ padding: '10px', borderBottom: '1px solid #ddd' }}>Topic</th>
              <th style={{ padding: '10px', borderBottom: '1px solid #ddd' }}>User Message</th>
              <th style={{ padding: '10px', borderBottom: '1px solid #ddd' }}>AI Response (Preview)</th>
              <th style={{ padding: '10px', borderBottom: '1px solid #ddd' }}>Model</th>
            </tr>
          </thead>
          <tbody>
            {entries.map((entry, index) => (
              <tr
                key={`${userid}-${index}`}
                style={{
                  backgroundColor: index % 2 === 0 ? '#FFF' : '#FEF8F5',
                  borderBottom: '1px solid #f0f0f0',
                }}
              >
                <td style={{ padding: '10px' }}>{entry.course || '-'}</td>
                <td style={{ padding: '10px' }}>{entry.topic || '-'}</td>
                <td style={{ padding: '10px' }}>{entry.usermessage || '-'}</td>
                <td style={{ padding: '10px' }}>
                  {entry.airesponse ? entry.airesponse.slice(0, 100) + '…' : '-'}
                </td>
                <td style={{ padding: '10px' }}>{entry.modelused || '-'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default AhaMomentUserTable;
